import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class UserService extends AbstractService {
	static endpoint = ENDPOINTS.users;

	static getUsers(queryParams) {
		return this.get({
			endpoint: this.endpoint,
			queryParams,
		});
	}

	static getUser(id) {
		return this.get({
			endpoint: `${this.endpoint}/${id}`,
		});
	}

	static getUserDevices(id) {
		return this.get({
			endpoint: `${this.endpoint}/${id}/devicetokens`,
		});
	}

	static searchUsers(queryParams, data) {
		return this.post({
			endpoint: this.endpoint,
			queryParams,
			data,
		});
	}

	static updateUser(data, contact, account) {
		return this.put({
			endpoint: `${this.endpoint}/${data.Id}`,
			data: {
				...data,
				...account,
				CoordinatorInfoModel: data.CoordinatorInfoModel || {},
				ContactViewModel: {
					...data.ContactViewModel,
					FirstName: contact.FirstName,
					LastName: contact.LastName,
					MobilePhone: contact.MobilePhone,
					StreetAddress1: contact.StreetAddress1,
					City: contact.City,
					StateId: contact.StateId,
					Zipcode: contact.Zipcode,
					IsAdmin: contact.IsAdmin,
					IsViewOnly: contact.IsViewOnly,
					IsCoordinator: contact.IsCoordinator,
				},
			},
		});
	}

	static sendTestNotification(userId, data) {
		return this.post({
			endpoint: `${this.endpoint}/${userId}/testnotification`,
			data,
		});
	}
}
